import {
  Box,
  Modal,
  Paper,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

export default function AnalysisServerModal({
  openStorageModal,
  setOpenStorageModal,
}: {
  openStorageModal: boolean;
  setOpenStorageModal: (open: boolean) => void;
}) {
  const queueData = [
    { trainLog_id: 1, project_id: 117, multi: false, step: "분석" },
    { trainLog_id: 2, project_id: 83, multi: false, step: "분류" },
    { trainLog_id: 3, project_id: 125, multi: true, step: "분석" },
  ];

  useEffect(() => {
    // const fetchQueueData = async () => {
    //   const response = await getProject();
    //   setQueueData(response);
    // };
    // fetchQueueData();
  }, []);
  return (
    <Modal open={openStorageModal} onClose={() => setOpenStorageModal(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "500px",
          backgroundColor: "var(--dk-surface, white)",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Typography>Appending project</Typography>
        <TableContainer component={Paper}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>순번</TableCell>
                <TableCell>Project ID</TableCell>
                <TableCell>Step</TableCell>
              </TableRow>
              {queueData.map((row, index) => (
                <TableRow key={row.trainLog_id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.project_id}</TableCell>
                  <TableCell>{row.step}</TableCell>
                </TableRow>
              ))}
            </TableHead>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
}
